import { useHistory, useLocation } from 'react-router-dom'
import styled from 'styled-components/macro'

import { EmptyState } from '@loadsmart/loadsmart-ui'
import { Button, Layout } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { parseQueryString, stringifyQueryString } from 'core/infra/queryString'
import IllustrationDepartingTruck from 'core/ui/assets/illustration-departing-truck.svg'

import { user } from 'legacy/utils/user'

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${getToken('spacing-12')};
`

export type EmptyTenderStateProps = {
  id: string
}

export function EmptyTenderState({ id }: EmptyTenderStateProps) {
  const shouldDisplaySignUpButton = !user.isLoggedIn()

  const location = useLocation()
  const history = useHistory()

  function handleSignUpButtonClick() {
    const search = {
      ...parseQueryString(location.search),
      signup: 'true',
    }

    history.replace({
      search: stringifyQueryString(search),
    })
  }

  return (
    <Wrapper>
      <Layout.Stack gap="spacing-4" align="center">
        <EmptyState
          illustration={IllustrationDepartingTruck}
          title="This load is no longer available :("
          description="Go to our carrier platform and find spot loads to keep your truck full"
          variant="page"
        />
        {shouldDisplaySignUpButton && (
          <Layout.Group>
            <Button type="button" variant="primary" onClick={handleSignUpButtonClick}>
              Sign up to start booking
            </Button>
          </Layout.Group>
        )}
      </Layout.Stack>
    </Wrapper>
  )
}
